import React, { Component, forwardRef } from 'react';
// import { Line } from 'react-chartjs';
import { Line, Pie, Bar } from 'react-chartjs-2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from 'jquery';
import { Collapse } from 'react-collapse';
// import * as Loader from 'react-loader-spinner';
import { ToastContainer, toast } from "react-toastify";

class Dashboard extends Component {

    constructor() {
        super();
        this.state = {
            selectedDate: new Date(),
            totalNoOfData: 0,
            displayConvByHour: true,
            displayConvByLang: true,
            displayConvBySourceType: true,
            displayConvByDomain: true,
            showLoader: false,
            displayChatHandle: true,

            convByHourData: {
                labels: [],
                datasets: [{
                    data: [],
                    label: "# of Sessions",
                    borderColor: "#3BA4DC",
                    pointColor: "#fff",
                    responsive: true,
                    pointStrokeColor: "#ccc",
                    pointHoverRadius: 10,
                    backgroundColor: ["rgba(60,167,224,0.4)"],
                    fill: true
                }]
            },

            chatHandleData: {
                labels: [],
                datasets: [{
                    data: [],
                    label: "# of Agents used",
                    borderColor: "#3BA4DC",
                    pointColor: "#fff",
                    responsive: true,
                    pointStrokeColor: "#ccc",
                    pointHoverRadius: 10,
                    backgroundColor: ["rgba(60,167,224,0.4)"],
                    fill: true
                }],
            },

            convByLanguage: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [
                            'rgb(110, 125, 171)',
                            'rgb(156, 222, 159)',
                            'rgb(255, 102, 102)',
                            'rgb(14, 177, 210)',
                            'rgb(106, 57, 55)',
                            'rgb(204, 255, 102)',
                            'rgb(247, 160, 114)',
                            'rgb(191, 181, 175)',
                            'rgb(244, 255, 82)',
                            'rgb(95, 80, 107)',
                            'rgb(105, 255, 241)',
                            'rgb(155, 136, 22)',
                            'rgb(242, 100, 25)'
                        ]

                    }
                ]
            },
            convBySourceType: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [
                            'rgb(110, 125, 171)',
                            'rgb(156, 222, 159)',
                            'rgb(255, 102, 102)',
                            'rgb(14, 177, 210)',
                            'rgb(106, 57, 55)',
                            'rgb(204, 255, 102)',
                            'rgb(247, 160, 114)',
                            'rgb(191, 181, 175)',
                            'rgb(244, 255, 82)',
                            'rgb(95, 80, 107)',
                            'rgb(105, 255, 241)',
                            'rgb(155, 136, 22)',
                            'rgb(242, 100, 25)'
                        ]
                    }
                ]
            },

            convByDomain: {
                labels: [],
                datasets: [
                    {
                        data: [],
                        backgroundColor: [
                            'rgb(110, 125, 171)',
                            'rgb(156, 222, 159)',
                            'rgb(255, 102, 102)',
                            'rgb(14, 177, 210)',
                            'rgb(106, 57, 55)',
                            'rgb(204, 255, 102)',
                            'rgb(247, 160, 114)',
                            'rgb(191, 181, 175)',
                            'rgb(244, 255, 82)',
                            'rgb(95, 80, 107)',
                            'rgb(105, 255, 241)',
                            'rgb(155, 136, 22)',
                            'rgb(242, 100, 25)'
                        ]

                    }
                ]
            }
        }
    }

    componentDidMount() {
        var selectedDate = this.state.selectedDate;

        setTimeout(() => {
            this.fetchConversationStatApi(selectedDate);
            this.fetchChatHandleStatApi(selectedDate);
            this.fetchDomainStatApi(selectedDate);
        }, 300);
    }

    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }



    fetchChatHandleStatApi = (selectedDate) => {
        var DailyConvController = this;
        var longDate = new Date(selectedDate.toDateString()).getTime();
        $.ajax({
            url: "/my-jeeva-api/chat-handle-stat",

            method: 'GET',
            data: {
                date: longDate,
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },

            success: function (res) {
                DailyConvController.state.chatHandleData["datasets"][0].data = [];
                DailyConvController.state.chatHandleData["labels"] = [];
                var datasetData1 = [];
                var labelData = [];
                var datasetData2 = [];
                if (res.success === true && res.result.length !== 0) {
                    for (var i = 0; i < res.result.length; i++) {
                        datasetData1.push(res.result[i].noOfReservedChatHandles);
                        labelData.push(res.result[i].time);
                    }
                    DailyConvController.state.chatHandleData["datasets"][0].data = datasetData1;
                    DailyConvController.state.chatHandleData["labels"] = labelData;

                    DailyConvController.state.showLoader = true;
                    DailyConvController.setState(DailyConvController.state);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    fetchConversationStatApi = (selectedDate) => {
        var DailyConvController = this;
        var longDate = new Date(selectedDate.toDateString()).getTime();
        $.ajax({
            url: "/my-jeeva-api/conversation-stat",

            method: 'GET',
            data: {
                date: longDate,
                timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },

            success: function (res) {
                console.log('Session stat', res.result);
                DailyConvController.state.convByHourData["datasets"][0].data = [];
                DailyConvController.state.convByHourData["labels"] = [];
                if (res.success === true && res.result.length !== 0) {
                    var dataSetDataAndLabel = DailyConvController.setDailyConvLabels(res.result);
                    DailyConvController.state.convByHourData["datasets"][0].data = dataSetDataAndLabel.datasetData;
                    DailyConvController.state.convByHourData["labels"] = dataSetDataAndLabel.labelData;

                    var totalNoOfData = 0
                    for (var i = 0; i < res.result.length; i++) {
                        var valueToInt = parseInt(res.result[i].value)
                        totalNoOfData += valueToInt;
                    }
                    DailyConvController.state.totalNoOfData = totalNoOfData
                    DailyConvController.state.showLoader = true;
                    DailyConvController.setState(DailyConvController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    setDailyConvLabels = (data) => {
        var DailyConvController = this;
        var labelData = [];
        var datasetData = [];
        for (var i = 0; i < data.length; i++) {
            if (data[i].key < "12") {
                if (data[i].key == "00") {
                    labelData.push("12 AM - 1 AM");
                } else {
                    if (data[i].key == "11") {
                        labelData.push(Number(data[i].key) + " AM"
                            + " - " + (Number(data[i].key) + 1) + " PM");
                    } else {
                        labelData.push(Number(data[i].key) + " AM"
                            + " - " + (Number(data[i].key) + 1) + " AM");
                    }
                }
            } else {
                if (data[i].key == "12") {
                    labelData.push(Number(data[i].key) + " PM"
                        + " - " + ((Number(data[i].key) - 12) + 1) + " PM");
                } else {
                    if (data[i].key == "23") {
                        labelData.push((Number(data[i].key) - 12) + " PM"
                            + " - " + ((Number(data[i].key) - 12) + 1) + " AM");
                    } else {
                        labelData.push((Number(data[i].key) - 12) + " PM"
                            + " - " + ((Number(data[i].key) - 12) + 1) + " PM");
                    }
                }
            }
            datasetData.push(data[i].value);
        }
        return { "datasetData": datasetData, "labelData": labelData };

    }





    fetchDomainStatApi = (selectedDate) => {
        var DailyConvController = this;
        var longDate = new Date(selectedDate.toDateString()).getTime();
        $.ajax({
            url: "/my-jeeva-api/domain-stat",

            method: 'GET',
            data: {
                date: longDate,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token")
            },

            success: function (res) {
                DailyConvController.state.convByDomain.labels = [];
                DailyConvController.state.convByDomain.datasets[0].data = [];
                if (res.success === true && res.result.length !== 0) {
                    for (var i = 0; i < res.result.length; i++) {
                        DailyConvController.state.convByDomain.labels.push(res.result[i].key);
                        DailyConvController.state.convByDomain.datasets[0].data.push(res.result[i].value);
                    }
                    DailyConvController.state.showLoader = true;
                    DailyConvController.setState(DailyConvController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    onDateChange = (date) => {
        this.state.selectedDate = date;
        this.fetchConversationStatApi(date);

        this.fetchDomainStatApi(date);
        this.fetchChatHandleStatApi(date);
    }

    refreshData = (id) => {
        var selectedDate = this.state.selectedDate;
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchConversationStatApi(selectedDate);

        this.fetchDomainStatApi(selectedDate);
        this.fetchChatHandleStatApi(selectedDate);
    }

    resetDate = () => {
        this.onDateChange(new Date());
    }

    displayConvByHour = () => {
        this.state.displayConvByHour ? this.setState({ displayConvByHour: false }) :
            this.setState({ displayConvByHour: true });
    }

    displayConvByLang = () => {
        this.state.displayConvByLang ? this.setState({ displayConvByLang: false }) :
            this.setState({ displayConvByLang: true });
    }

    displayConvBySourceType = () => {
        this.state.displayConvBySourceType ? this.setState({ displayConvBySourceType: false }) :
            this.setState({ displayConvBySourceType: true });
    }

    displayConvByDomain = () => {
        this.state.displayConvByDomain ? this.setState({ displayConvByDomain: false }) :
            this.setState({ displayConvByDomain: true });
    }

    displayChatHandle = () => {
        this.state.displayChatHandle ? this.setState({ displayChatHandle: false }) :
            this.setState({ displayChatHandle: true });
    }
    goBackFromSubTab = () => {
        this.props.history.push({
            pathname: "/projectmgmt/reports"
        });
    }

    render() {
        return (
            <div>
                {/* <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!(this.state.showLoader)}
                    height={400}
                    width={50}
                    style={{ textAlign: 'center' }} /> */}
                {/* for toaster */}
                <link rel="stylesheet" href="./assets/css/ReactToastify.css" />
                <div
                    style={{ display: this.state.showLoader ? 'block' : 'none' }}
                >
                    <link rel="stylesheet" href="./assets/css/styles.css" />

                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <div className="container-fluid">
                        <div className="row" style={{ position: 'absolute', width: '87%' }}>
                            <div className="col-sm-7">
                                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '10px', marginLeft: '7px' }}>JEEVA's Sessions</h6>
                            </div>

                            <ToastContainer className="Toast-at-center" />

                            <div className="col-sm-5 p-0">
                                <div className="d-flex flex-row-reverse pt-2">
                                    <button className="btn action-button"
                                        style={{ marginTop: '0px' }}
                                        onClick={this.refreshData} title="Refresh">
                                        <img src="./assets/images/refresh_white_24dp.png" />
                                    </button>

                                    <button className="btn action-button"
                                        style={{ marginTop: '0px' }}
                                        onClick={this.resetDate}>Reset</button>

                                    <DatePicker
                                        id="date"
                                        selected={this.state.selectedDate}
                                        onChange={this.onDateChange}
                                        dateFormat="MM/dd/yyyy">
                                    </DatePicker>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ marginLeft: "8px", marginTop: '5vw' }}>
                        <h6>
                            <img src={this.state.displayConvByHour ? './assets/images/downward_arrow.png' :
                                './assets/images/upArrow.png'}
                                onClick={this.displayConvByHour} />Sessions by Hour<br /><br />
                            <label>Total No Of Sessions : {this.state.totalNoOfData}</label></h6>
                        <div className="col-lg-12">
                            <Collapse isOpened={this.state.displayConvByHour}>

                                <div className="card filled-line-chart">
                                    <div className="card-body">
                                        <div className="position-relative mb-4">
                                            <Line data={this.state.convByHourData} width={1000} height={200}/>

                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>

                        <h6>
                            <img src={this.state.displayChatHandle ? './assets/images/downward_arrow.png' :
                                './assets/images/upArrow.png'}
                                onClick={this.displayChatHandle} />Concurrent Patient Sessions<br /><br />
                        </h6>
                        <div className="col-lg-12">
                            <Collapse isOpened={this.state.displayChatHandle}>

                                <div className="card filled-line-chart">
                                    <div className="card-body">
                                        <div className="position-relative mb-4">
                                            <Line data={this.state.chatHandleData} width={1000} height={200}
                                                options={{
                                                    legend: {
                                                        onClick: null,
                                                    }
                                                }} />
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>


                        <h6>
                            <img src={this.state.displayConvByDomain ? './assets/images/downward_arrow.png' :
                                './assets/images/upArrow.png'}
                                onClick={this.displayConvByDomain} />Sessions by Domain<br /><br />

                        </h6>
                        <div className="col-lg-12" />
                        <div className="col-lg-6">
                            <Collapse isOpened={this.state.displayConvByDomain}>
                                <div className="card monthly-conversation-chart">
                                    <div className="card-body">
                                        <div className="chartHeight">
                                            <Pie data={this.state.convByDomain} />
                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Dashboard;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/Dashboard.js